import { useEffect, useState } from "react";

import styles from "./style.module.scss";
import cx from "classnames";
import { ProviderOrderDataType } from "@/api/ProviderOrderApi";

type ProviderOrderDocumentInfoProps = {
  providerOrder: ProviderOrderDataType,
}

const ProviderOrderDocumentInfo = (props: ProviderOrderDocumentInfoProps) => {
  const { providerOrder } = props;

  useEffect(() => {
  }, []);

  return (
    <div className="info einvoice-info">
      <div className="cliente-details">
        <div className="cliente">
          <label className={cx("icon-holder", [styles.propTitle])}>Provedor: </label>
          {providerOrder.providerNombre}
        </div>
        <div className="cliente">
          <label className={cx("icon-holder", [styles.propTitle])}>Ordeno: </label>
          {providerOrder.pedidoPor}
        </div>
        <div className="direccion">
          <label className={cx("icon-holder", [styles.propTitle])}>Recoge: </label>
          {providerOrder.entregarA}
        </div>
        <div className="direccion">
          <label className={cx("icon-holder", [styles.propTitle])}>Identificacion: </label>
          {providerOrder.identificacion}
        </div>
      </div>
    </div >
  );
}

export default ProviderOrderDocumentInfo
  ;
